import { jsx } from '@emotion/react/jsx-runtime';
import { cloneElement, Fragment } from 'react';

const linkContents = ({
  children,
  iconSvg,
  iconSide
}) => {
  const spacer = /* @__PURE__ */ jsx(Fragment, { children: "\xA0\xA0\xA0\xA0\xA0\xA0" }, "spacer");
  const linkContents2 = [children];
  if (iconSvg) {
    if (iconSide === "left") {
      linkContents2.unshift(
        spacer,
        cloneElement(iconSvg, {
          key: "svg"
        })
      );
    } else {
      linkContents2.push(
        spacer,
        cloneElement(iconSvg, {
          key: "svg"
        })
      );
    }
  }
  return linkContents2;
};

export { linkContents };
